 <template>
  <div class="p-6 max-w-7xl mx-auto">
    <!-- Header con gradiente moderno -->
     <!-- Título tipo etiqueta código -->
    <div class="flex justify-start mb-3">
        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
        &lt;UploadSolicitudes&gt;
      </span>
    </div>

    <div class="  overflow-hidden rounded-2xl bg-gradient-to-r from-green-700 via-purple-600 to-green-600 p-8 mb-8 shadow-xl">
      <div class=" inset-0 bg-white/10 backdrop-blur-sm"></div>
      <div class="  z-1 flex items-center justify-between">
        <div>
         
          <h2 class="text-2xl font-bold text-white flex items-center gap-3">
            <span class="bg-white/20 p-2 rounded-xl  ">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
            </span>
            Subir archivo .CSV {{ aa_borrador}}
          </h2>
        </div>
        <div class="hidden md:block bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 text-white/90 text-xs">
          <span class="font-semibold">Separador:</span> PUNTO Y COMA
        </div>
      </div>
    </div>

    <!-- Contenedor principal con efecto glass -->
    <div class="bg-white/80   rounded-2xl shadow-1xl border border-white/20 p-6 mb-6">
      <div v-if="showForm" class="space-y-6">
        <!-- Alerta de error -->
        <div v-if="error_monto_modificacion_ya_alcanzado" class="relative overflow-hidden rounded-xl bg-red-50 border border-red-200 p-4">
          <div class="flex items-center gap-3">
            <span class="text-2xl">⚠️</span>
            <p class="text-red-600 text-sm font-medium">Error: monto ingresado excesivo</p>
          </div>
        </div>

        <!-- Card de instrucciones y upload -->
        <div class="  overflow-hidden rounded-xl bg-gradient-to-br from-gray-50 to-white border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
          <!-- Badge decorativo -->
          <div class="absolute top-0 right-0">
            <div class="bg-gradient-to-l from-indigo-500/10 to-transparent px-6 py-2 rounded-bl-2xl">
              <span class="text-xs text-indigo-600 font-mono">CSV</span>
            </div>
          </div>

          <div class="space-y-4">
            <div class="flex items-start gap-3 text-xs text-gray-600 bg-gray-50 rounded-lg p-4 border border-gray-100 font-mono overflow-x-auto">
              <span class="text-indigo-500 font-bold shrink-0">Columnas:</span>
              <span class="break-all">RESPONSABLE;TIPO PRESUPUESTO;TERRITORIO;NOMBRE C DE COSTO;COD CENTRO DE COSTO;AGRUPACION DE CUENTAS;CUENTA;GLOSA;ene-27;feb-27;mar-27;abr-27;may-27;jun-27;jul-27;ago-27;sep-27;oct-27;nov-27;dic-27;TOTAL 2027</span>
            </div>

            <!-- Área de upload -->
            <div class= "">
              <div class="flex flex-col items-center justify-center w-full">
                <label for="file-input" class="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-300 hover:bg-indigo-50/50"
                  :class="error_file ? 'border-red-400 bg-red-50/50' : 'border-gray-300 hover:border-indigo-400'">
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg class="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <p class="mb-2 text-sm text-gray-500"><span class="font-semibold">Haz clic para subir</span> o arrastra y suelta</p>
                    <p class="text-xs text-gray-400">Archivos CSV (PUNTO Y COMA)</p>
                  </div>
                  <input
                    type="file"
                    name="file"
                    id="file-input"
                    :key="fileKey"
                    @change="onFileChange"
                    class="hidden"
                    accept=".csv"
                  />
                </label>
                
                <!-- Nombre del archivo seleccionado -->
                <div v-if="file_url" class="w-full mt-3 flex items-center gap-2 text-sm bg-indigo-50 rounded-lg px-4 py-2 border border-indigo-200">
                  <span class="text-indigo-600">📄</span>
                  <span class="text-gray-700 font-medium truncate flex-1">{{ file_url }}</span>
                  <button @click="limpiarArchivo" class="text-gray-400 hover:text-red-500 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <p v-if="error_file" class="w-full mt-2 text-red-500 text-xs flex items-center gap-1">
                  <span>❌</span> Debe subir archivo CSV adjunto
                </p>
              </div>

              <!-- Barra de progreso -->
              <div v-if="uploading" class="w-full mt-4">
                <div class="">
                  <div class="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                    <div class="bg-gradient-to-r from-indigo-500 to-purple-500 h-2.5 transition-all duration-300 rounded-full" :style="{ width: uploadProgress + '%' }"></div>
                  </div>
                  <p class="text-xs text-gray-500 mt-2 flex items-center justify-between">
                    <span>{{ uploadProgressGlosa }}</span>
                    <span class="font-mono font-semibold text-indigo-600">{{ uploadProgress }}%</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
  <a v-if="!importacion_completada && error_file" :href="apiUrl + '/api/v1/solicitud/logs/import/fails'" target="_blank" 
             class="inline-flex items-center gap-2 px-4 py-2  font-mono bg-red-900 text-white rounded-lg hover:bg-indigo-100 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Ver errores
          </a> 
      <!-- Estado de modificación grabada -->
      <div v-if="!showForm" class="text-center py-12">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-800">Modificación grabada</h3>
        <p class="text-sm text-gray-500">Los datos se han guardado correctamente</p>
      </div>

      <!-- Footer con botón de acción -->
      <div class="mt-6 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-between gap-4">
        <div class="text-xs text-gray-500">
          <span class="font-mono">⚡</span> Archivo CSV con separador <span class="font-semibold">PUNTO Y COMA</span>
        </div>
        <div class="flex items-center gap-3">
          <button
            v-if="!loading"
            @click="uploadFile"
            class="relative overflow-hidden px-8 py-3 rounded-xl font-medium text-white transition-all duration-300 shadow-lg hover:shadow-xl active:scale-95"
            :class="enable_btn_grabar === false 
              ? 'bg-gray-300 cursor-not-allowed shadow-none' 
              : 'bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700'"
            :disabled="enable_btn_grabar === false"
          >
            <span class="relative z-10 flex items-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
              Importar archivo
            </span>
          </button>
          <div v-if="loading" class="flex items-center gap-3">
            <div class="w-8 h-8 border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin"></div>
            <span class="text-sm text-gray-600">Procesando...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultado de importación -->
    <div v-if="importacion_completada" class="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-2xl border border-white/20 p-6 mt-6">
      <div class="flex items-center gap-3 mb-6">
        <span class="text-2xl">📊</span>
        <h3 class="text-xl font-bold text-gray-800">Resultado de la importación</h3>
      </div>

      <!-- Tarjetas de estadísticas -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-gray-500">Registros leídos</span>
            <span class="text-2xl font-bold text-gray-700">{{ registros_leidos }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-green-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-green-600">Nuevos</span>
            <span class="text-2xl font-bold text-green-600">{{ registros_creados }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-blue-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-blue-600">Actualizados</span>
            <span class="text-2xl font-bold text-blue-600">{{ registros_actualizados }}</span>
          </div>
        </div>
        <div class="bg-white rounded-xl p-4 shadow-sm border border-red-100 hover:shadow-md transition-shadow">
          <div class="flex items-center justify-between">
            <span class="text-sm text-red-600">Erróneos</span>
            <span class="text-2xl font-bold" :class="registros_erroneos > 0 ? 'text-red-600' : 'text-gray-700'">
              {{ registros_erroneos }}
            </span>
          </div>
        </div>
      </div>

      <!-- Estado y logs -->
      <div class="flex flex-wrap items-center justify-between gap-4 p-4 bg-white rounded-xl border border-gray-100">
        <div class="flex items-center gap-4">
          <span class="text-sm font-medium text-gray-700">Estado:</span>
          <span
            v-if="status_importacion"
            class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-green-100 text-green-700"
          >
            <span class="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            ✔ Importación exitosa
          </span>
          <span
            v-else
            class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-red-100 text-red-700"
          >
            <span class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
            ✖ Importación defectuosa
          </span>
        </div>
        <div class="flex items-center gap-3 text-sm">
          <a :href="apiUrl + '/api/v1/solicitud/logs/import/success'" target="_blank" 
             class="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Ver logs
          </a>

          

        </div>
      </div>
    </div>

 
    <!-- Tabla de detalles -->
    <div v-if="detalles && detalles.length > 0" class="mt-6 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
      <!-- Encabezado de tabla con contador -->
      <div class="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
        <div class="flex items-center gap-3">
          <span class="text-2xl">📋</span>
          <h4 class="font-semibold text-gray-800">Detalle de registros</h4>
          <span class="text-xs bg-indigo-100 text-indigo-600 px-2 py-1 rounded-full">{{ detalles.length }} registros</span>
        </div>
  
      </div>

      <!-- Scroll de tabla -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-gray-700 font-mono">
          <thead class="bg-gradient-to-r from-gray-100 to-gray-50 sticky top-0">
            <tr>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Fecha</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Centro</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Nombre Centro</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Cuenta</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Nombre cuenta</th> 
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Glosa</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Ene</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Feb</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Mar</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Abr</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">May</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Jun</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Jul</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Ago</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Sep</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Oct</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Nov</th>
              <th class="text-center py-3 px-2 text-xs font-mono uppercase tracking-wider text-gray-600">Dic</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(item, index) in detalles"
              :key="item.indice"
              class="border-b hover:bg-indigo-50/50 transition-colors"
              :class="{ 'bg-gray-50/50': index % 2 !== 0 }"
            >
              <td class="px-2 py-2.5 text-sm text-center">{{ item.fecha }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-medium">{{ item.centro }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.centro_nombre }}</td>
              <td class="px-2 py-2.5 text-sm text-center font-mono">{{ item.cuenta }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.cuenta_nombre }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ item.glosa }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.ene) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.feb) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.mar) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.abr) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.may) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.jun) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.jul) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.ago) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.sep) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.oct) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.nov) }}</td>
              <td class="px-2 py-2.5 text-sm text-center">{{ $formatoMiles(item.dic) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/axios";

export default {
  name: "ModalIngresoMes",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    centro_id: {
      type: Number,
    },
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    datosModificacion: {
      type: Object,
    },
    modificaciones_bloqueados: {
      type: Boolean,
    },
    timestamp: {
      type: String,
    },
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_DJANGO_API_URL;
    },
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    timestamp: function () {
      this.recargaDatos(this.datosModificacion);
    },
  },
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      console.log("Archivo seleccionado:", this.selectedFile);
    },

    async uploadFile() {
      if (!this.selectedFile) return;
      const formData = new FormData();
      
      formData.append("file", this.selectedFile);
      formData.append("glosa", this.glosa);
      this.status_importacion = false;
      this.error_file = false;
      this.importacion_completada = false;
      this.uploadProgress = 0;
      this.uploadProgressGlosa = "Subiendo archivo...";
      this.uploading = true;
      this.loading = true;
      try {
        const resp = await api.post("/api/v1/solicitud/upload/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        });
        
       
        if (resp.data.error) {
         
          this.importacion_completada= false;
          this.uploadProgressGlosa = "";
          this.uploadProgress = 0;
          return;
        }
        this.status_importacion = true;
        this.detalles = resp.data.detalles;
       
        this.suma_totales = resp.data.suma_totales;
    
        this.registros_leidos = resp.data.registros_leidos;
        this.registros_creados = resp.data.registros_creados;
        this.registros_actualizados = resp.data.registros_actualizados;
        this.registros_erroneos = resp.data.registros_erroneos;
        
       

        

        this.loading = false; 
        this.file_url = resp.data.file_url;
        this.uploadProgressGlosa = resp.data.message;
        this.fileKey++;

        this.importacion_completada = true;
      } catch (error) {
        this.importacion_completada = false;
        this.error_file = true;
        this.uploadProgressGlosa = "Error al subir archivo";
        this.loading=false
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.detail;
         
          console.error("Error al enviar:", error);
          console.log("Código:", status);
          console.log("Mensaje:", message);
        }
      }
    },
    async borracarga() {

      if (!confirm('¿Confirma que desea borrar este registro?')){
        return false;
      }

      this.uploadProgress = 0;
      const formData = new FormData();
      formData.append("libromayorgeneral_id", this.libromayorgeneral_id);
      try {
        const resp = await api.post("/api/v1/solicitudes/upload/delete/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (resp.data.error) {
          alert(resp.data.error);

          return;
        }

        this.loading = false;
        this.detalles = [];
        this.libromayorgeneral_id = false;
        this.importacion_completada=false;
        this.status_eliminacion=true;
  

      } catch (error) {
        const status = error.response.status;
        const message = error.response.data?.detail;
        console.error("Error al enviar:", error);
        console.log("Código:", status);
        console.log("Mensaje:", message);
      }
    },
  },
  data() {
    return {
      aa_borrador: this.$store.state.auth.userLogin.año_borrador,
      glosa: "",
      presupuesto_id: 0,
      ingreso_id: 0,
      accion_id: 0,
      mes: 0,
      file_url: "",

      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],
      monto_mensual: "",
      array_monto_mensual: new Array(13).fill(0),
      marca_modificacion: new Array(13),
      cuentaSelec: 0,
      centroSelec: 0,

      objMesYMonto: {},
      mesSelec: 0,

      reasignar_isOn: false,
      accion: "Disminución",
      error_props: false,
      error_monto: false,
      error_file: false,
      error_cuenta: false,
      error_centro: false,
      error_selecciona_cuenta: false,
      error_saldo_insuficiente: false,
      error_falta_selec_mes: false,
      error_ingresos_insuficientes: false,
      error_monto_modificacion_ya_alcanzado: false,
      error_faltan_movimientos: false,
      fileKey: 0,
      enable_btn_grabar: true,
      puede_restar: false,
      puede_sumar: false,
      puede_mostrar_meses: false,
      porcentaje_movimientos: 0,
      list_total_movimientos: [],
      list_movimientos: [],

      total_movimientos: 0,

      showForm: true,

      uploadProgress: 0,
      uploading: false,
      uploadProgressGlosa: "",
      selectedFile: "",
      detalles: [],
      libromayorgeneral_id: false,
      loading: false,

      suma_debito: 0,
      suma_credito: 0,
      checksum_debito: 0,
      checksum_credito: 0,
      status_importacion: "",
      registros_leidos: 0,
      registros_creados: 0,
      registros_actualizados: 0,
      registros_erroneos: 0,
      importacion_completada: false,
      status_eliminacion:false
    };
    /**
     * list_movimientos
     * 
     [{
        "indice":0,
        "centro":37,
        "centro_datos":"VCO069000000000 - Amigos del Parque Pumalin",
        "cuenta":32,
        "cuenta_datos":"4.5.1030.40.15 - Alimentación animales de trabajo",
        "objMesMonto":{
          "mes":5,
          "monto":4
        }
     }]
     */
  },
  mounted() {
    this.enable_btn_grabar = true;

    this.file_url = "";
  },
};
</script>

<style scoped></style>
